import * as Ariakit from '@ariakit/react';
import { forwardRef } from '@wordpress/element';
import warning from '@wordpress/warning';
import type { WordPressComponentProps } from '../context';
import { useCompositeContext } from './context';
import type { CompositeItemProps } from './types';

export const CompositeItem = forwardRef<
	HTMLButtonElement,
	WordPressComponentProps< CompositeItemProps, 'button', false >
>( function UnforwardedCompositeItem( props, ref ) {
	const context = useCompositeContext();

	// @ts-expect-error The store prop is undocumented and only used by the
	// legacy compat layer. The `store` prop is documented, but its type is
	// obfuscated to discourage its use outside of the component's internals.
	const store = ( props.store ?? context.store ) as Ariakit.CompositeStore;
	if ( ! store ) {
		warning(
			'Composite.Item: Missing composite state. Render inside Composite to enable composite keyboard behavior.'
		);
	}

	return <Ariakit.CompositeItem store={ store } { ...props } ref={ ref } />;
} );
